<h1>{{ artist.name }}</h1>

<h3>Full Discography for {{ artist.name }}</h3>
<h3>Click the <b>album cover</b> for more information</h3>

<mat-card
  [ngStyle]="{
    'background-image': 'url(' + artist.images[0].url + ')',
    'background-position': 'center  center',
    'background-size': '100% auto',
    'background-repeat': 'no-repeat',
    height: '450px',
    overflow: 'hidden'
  }"
>
  <mat-card-header>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
</mat-card>

<h1>Full Discography</h1>

<div fxLayout="row wrap" fxLayout.xs="column">
  <!-- Single "Responsive" Card-->
  <div *ngFor="let album of albums" fxFlex [style.margin]="'20px'">
    <mat-card [style.min-width]="'200px'">
      <mat-card-header>
        <mat-card-title>{{ album.name }}</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
      </mat-card-header>
      <a
        class="nav-link"
        routerLink="/album/{{ album.id }}"
        routerLinkActive="active"
      >
        <img
          mat-card-image
          class="album-cover"
          src="{{ album.images[0].url }}"
          alt="album art"
        />
      </a>
      <strong>Release Date: </strong>{{ album.release_date }}<br />
      <strong>Tracks: </strong>{{ album.total_tracks }}
    </mat-card>
  </div>
  <!-- -->
</div>
